import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import ReviewsPageHeaderFooterWrapper from 'bundles/reviews/components/ReviewsPageHeaderFooterWrapper';
import UnifiedPageRolloutExperimentDataProvider from 'bundles/unified-description-page-common/providers/UnifiedPageRolloutExperimentDataProvider';

import 'css!bundles/reviews/styl/index';

const ReviewsApp = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="rc-ReviewsApp">
      <UnifiedPageRolloutExperimentDataProvider>
        <ReviewsPageHeaderFooterWrapper>{children}</ReviewsPageHeaderFooterWrapper>
      </UnifiedPageRolloutExperimentDataProvider>
    </div>
  );
};

export default compose<{}, React.PropsWithChildren>(
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'reviews',
      page: 'reviews',
    },
  }))
)(ReviewsApp);
